import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { useLang } from "@/i18n";
import { SectionLabel } from "./ui";
import { Reveal } from "./Reveal";

export const FAQ = () => {
  const { t } = useLang();
  const q = t.faq;
  return (
    <section id="faq" data-testid="faq-section" className="py-24 md:py-32 bg-white">
      <div className="max-w-4xl mx-auto px-6 md:px-10">
        <Reveal className="text-center max-w-2xl mx-auto">
          <SectionLabel>{q.label}</SectionLabel>
          <h2 className="mt-4 font-display text-3xl sm:text-4xl lg:text-5xl font-semibold text-navy-900 leading-tight">
            {q.title}
          </h2>
          <p className="mt-5 text-lg text-charcoal-700 leading-relaxed">{q.sub}</p>
        </Reveal>

        <Reveal delay={0.1} className="mt-12">
          <Accordion type="single" collapsible className="space-y-3">
            {q.items.map((f, i) => (
              <AccordionItem
                key={i}
                value={`item-${i}`}
                data-testid={`faq-item-${i}`}
                className="border border-navy-100 rounded-2xl px-6 bg-[#FAFAFC] data-[state=open]:border-gold-500/50 transition-colors"
              >
                <AccordionTrigger className="text-left font-display text-lg font-semibold text-navy-900 hover:no-underline py-5">
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="text-charcoal-700 leading-relaxed text-[15px] pb-5">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>

        <Reveal className="mt-10">
          <p className="text-center text-sm text-charcoal-700/70 leading-relaxed max-w-2xl mx-auto">
            {q.disclaimer}
          </p>
        </Reveal>
      </div>
    </section>
  );
};
